const Search = (props) => (
  <svg
    width='11'
    height='10'
    viewBox='0 0 11 10'
    fill='none'
    {...props}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.28223 0C6.64726 0 8.56438 1.91721 8.56445 4.28223C8.56445 5.21316 8.26621 6.07381 7.76172 6.77637C7.79243 6.79436 7.82215 6.81403 7.84961 6.83691L10.4844 9.03223C10.7417 9.24663 10.7417 9.59517 10.4844 9.80957C10.2272 10.0236 9.91924 10.0237 9.66211 9.80957L6.94434 7.63477C6.21327 8.21604 5.28879 8.56445 4.28223 8.56445C1.91721 8.56438 0 6.64726 0 4.28223C6.83452e-05 1.91725 1.91725 6.83447e-05 4.28223 0ZM4.28125 1.24609C2.60493 1.24635 1.24635 2.60493 1.24609 4.28125C1.24609 5.95779 2.60477 7.31712 4.28125 7.31738C5.95795 7.31738 7.31738 5.95795 7.31738 4.28125C7.31712 2.60477 5.95779 1.24609 4.28125 1.24609Z'
      fill='#256BD1'
    />
  </svg>
);
export default Search;
